import axios from "axios";
import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
import AES from "crypto-js/aes";

import {
  REACT_APP_ENV_TYPE,
  AWS_INTERACTIVES_BUCKET_NAME
} from "../../../../../config";
import getInteractivesS3Records from "app/utils/app-record-management/getInteractivesS3Records";

// Values in data are encrypted using the below KEY in google sheet.
const KEY = "sacho";

//
// Dropdown
// -----------------------------------------------------------------------
export const areaDropdownValueToLabelFunction = value => value;

/**
 *  ---  Load questions list ----
 */
export const GetQuestionList = async (dataFileName, DUMMY_LIST) => {
  const developBaseUrl =
    "https://ninehub.s3-us-west-2.amazonaws.com/configs/political-monitor"; //some pubic S3
  const stagingBaseUrl =
    "https://s3-ap-southeast-2.amazonaws.com/interactives-hub-development-v1.apse2.ffx.io/configs/political-monitor";
  const productionBaseUrl = "production"; //  "https://www.smh.com.au/interactive/2021/political-monitor/data";

  const baseUrl =
    process.env.REACT_APP_ENV_TYPE === "development"
      ? developBaseUrl
      : process.env.REACT_APP_ENV_TYPE === "staging"
        ? stagingBaseUrl
        : productionBaseUrl;

  let result = { data: [], errors: [] };

  // For staging & production we need "node server side request" to get json file from Interactives S3 in AWS
  // if production, HUB client does not have access to Interactives S3

  if (baseUrl === stagingBaseUrl || baseUrl === productionBaseUrl) {
    const key = `data-store/feeds/political-monitor/live/${dataFileName}`;
    const requestData = { key: key };

    try {
      const appsRequest = await getInteractivesS3Records(requestData);
      const { data } = appsRequest;

      const recData = JSON.parse(data.record);
      const enData = decryptValues(recData.sections);
      result.data.sections = enData;
      return result;
    } catch (error) {
      result.data = [];
      result.errors = ["Question list not found. Try again later."];
      return result;
    }

    // Using a public S3 for development, configure the key and secret in .env file
  } else {
    try {
      const questionListUrl = `${baseUrl}/${dataFileName}?v=${Math.random()}`;
      const appsRequest = await axios.get(questionListUrl);
      const { data } = appsRequest;
      const enData = decryptValues(data.sections);
      result.data.sections = enData;
      return result;
    } catch (error) {
      console.log("--GetQuestionList---");
      console.log(error);
      result.data = [];
      result.errors = ["Something went wrong. Try again later."];
      return result;
    }
  }
};

/**
 * Decrypts all the values in json data
 * @param {array} dt
 * @returns array
 */

function decryptValues(dt) {
  if (dt) {
    dt.forEach(item => {
      const quest = item.question;
      if (quest.includes("!e!")) {
        const nq = quest.replace(/\!e!/g, "");
        const decrypted = AES.decrypt(nq, KEY);
        item.question = decrypted.toString(Utf8);
      }
      item.answers.forEach(answer => {
        if (answer.age) {
          doDecriptValue(answer.age);
        }
        if (answer.states) {
          doDecriptValue(answer.states);
        }
        if (answer.gender) {
          doDecriptValue(answer.gender);
        }
        if (answer.categories) {
          doDecriptValue(answer.categories);
        }
      });
      if (item.subSections) {
        if (item.subSections.length > 0) {
          item.subSections = decryptValues(item.subSections);
        }
      }
    });
  }
  return dt;
}

function doDecriptValue(data) {
  data.forEach(item => {
    if (item.timeseries) {
      item.timeseries.forEach(ts => {
        if (ts.value) {
          const tsObj = ts.value.toString();
          if (tsObj.includes("!e!")) {
            const nv = tsObj.replace(/\!e!/g, "");
            const decrypted = AES.decrypt(nv, KEY);
            ts.value = +decrypted.toString(Utf8);
          }
        }
      });
    }
  });
}

export default {
  areaDropdownValueToLabelFunction,
  GetQuestionList
};
